<form
    class="drop-zone-container"
    [class.drag-over]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
>
    <app-form-section>
        <div *ngIf="f.file?.value" class="delete-button-container">
            <button
                *appHasPermissions="[permissions.WriteAgreement]"
                type="button"
                class="secondary delete-button"
                (click)="removeFile()"
                [disabled]="uploading"
            >
                <span class="material-symbols-rounded" aria-hidden="true">delete</span>
            </button>
        </div>
        <div *ngIf="!f.file?.value?.fileName">
            <label for="{{ id }}" class="file-upload">
                <input
                    *appHasPermissions="[permissions.WriteAgreement]"
                    id="{{ id }}"
                    type="file"
                    (click)="resetFileUpload($event)"
                    (change)="uploadReport($event)"
                    [multiple]="false"
                    [disabled]="uploading"
                />
                <ng-template #uploadInput>
                    <span>{{ 'FEATURES.AGREEMENTS.UPLOAD_CONTRACT' | translate }}</span>
                    <span *ngIf="f.file?.value">({{ f.file.value.fileName }})</span>
                </ng-template>
                <app-spinner *ngIf="uploading; else uploadInput" size="s3" />
                <span class="material-symbols-rounded" aria-hidden="true" *ngIf="!uploading">cloud_upload</span>
            </label>
            <div
                *ngIf="!disabled"
                class="drop-zone"
                (click)="fileInput.click()"
                (keyup.enter)="fileInput.click()"
                tabindex="0"
                role="button"
            >
                <ng-content></ng-content>
                <p *ngIf="!uploading">{{ 'FEATURES.AGREEMENTS.UPLOAD_CONTRACT_DRAG_FROP_AREA' | translate }}</p>
                <input
                    type="file"
                    accept="application/pdf"
                    (click)="resetFileUpload($event)"
                    (change)="uploadReport($event)"
                    style="display: none"
                    #fileInput
                />
            </div>
        </div>
        <ngx-extended-pdf-viewer
            class="pdf-viewer"
            *ngIf="showViewer()"
            [src]="pdfByteArray"
            [showPrintButton]="false"
            [showFindButton]="true"
            [showOpenFileButton]="false"
            [showPagingButtons]="false"
            [showZoomButtons]="true"
            [showSidebarButton]="false"
            useBrowserLocale="true"
            showSidebar="false"
            [textLayer]="true"
            [handTool]="false"
            zoom="auto"
        >
        </ngx-extended-pdf-viewer>
    </app-form-section>
</form>
